import { 
    REQUEST_LIVE_FEED_FETCH_EM,
    FETCH_LIVE_FEED_EM_SUCCESS,
    FETCH_LIVE_FEED_EM_FAILURE,
    CLEAR_FETCH_LIVE_FEED_EM_STATES
} from './liveFeed.types';

let initialState = {
    reload: false,
    response : {},
    error : null,
    loading : false
}

const fetchLiveFeedEmReducer = (state = initialState, action) => {

    switch(action.type) {
        case REQUEST_LIVE_FEED_FETCH_EM :
            return {
                ...state,
                loading: true,
                error: null
            }

        case FETCH_LIVE_FEED_EM_SUCCESS:
            return {
                ...state,
                loading : false,
                response : action.payload,
                reload: false
            }

        case FETCH_LIVE_FEED_EM_FAILURE:
            return {
                ...state,
                loading : false,
                error : action.payload,
                reload: false
            }
        
        case CLEAR_FETCH_LIVE_FEED_EM_STATES:
            return {
                ...state,
                loading : false,
                response : {},
                error : null,
                reload: false
            }

        default:
            return state;
    }
}

export default fetchLiveFeedEmReducer